import styled from 'styled-components'

import { SvgImage } from 'components/SvgImage'

import { Color } from 'root-constants'

export const StyledTrustBadge = {
  Wrapper: styled.div`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,
  Rating: styled.div`
    display: flex;
    gap: 2px;
  `,
  Star: styled(SvgImage)`
    flex-shrink: 0;
  `,
  Text: styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    font-style: italic;
    color: ${Color.INK_BASE};
  `,
}
